// This file is generated by Plop. Don't edit it manually.
export default '6c8ea2fb8fb3999a6802c7805cfccbb0';
